import React, { useState, useEffect } from 'react'

import { DateField, Divider, Table, Typography, Space, Tag, Icons, List, Row, Col } from '@pankod/refine-antd'
import { DatePicker, TimePicker, Tabs } from 'antd'
import type { Moment } from 'moment'
import type { TabsProps } from 'antd'
import dayjs from 'dayjs'
import moment from 'moment'

import { useSelect } from '@pankod/refine-core'

type ITestEventSlotsShow = {
  listOfSlots?: { test_track_id: string; list_of_slots: { date: string; start_time: string; end_time: string }[] }[]
  style?: React.CSSProperties
  editable?: boolean
}

// const sampleData = [
//   {
//     id: '648ab88e-8c92-49bb-8dc0-b4afc831fa3e',
//     slots: {
//       '2022-10-07T06:24:48+0000': [
//         ['2022-10-07T04:30:00.590Z', '2022-10-07T13:30:00.621Z'],
//         ['2022-10-07T11:30:00.590Z', '2022-10-07T13:30:00.621Z'],
//       ],
//       '2022-10-08T06:39:33.615Z': [
//         ['2022-10-07T04:30:00.590Z', '2022-10-07T13:30:00.621Z'],
//         ['2022-10-07T11:30:00.590Z', '2022-10-07T13:30:00.621Z'],
//       ],
//     },
//   },
//   {
//     id: '9f78aff5-9a15-46e4-9c17-d5373df0d1e2',
//     slots: {
//       '2022-10-08T06:39:33.615Z': [
//         ['2022-10-07T04:30:00.590Z', '2022-10-07T13:30:00.621Z'],
//         ['2022-10-07T11:30:00.590Z', '2022-10-07T13:30:00.621Z'],
//       ],
//     },
//   },
// ]

const newSampleData = [
  {
    test_track_id: '648ab88e-8c92-49bb-8dc0-b4afc831fa3e',
    list_of_slots: [
      { date: '2022-10-07T06:24:48+0000', start_time: '2022-10-07T04:30:00.590Z', end_time: '2022-10-07T13:30:00.621Z' },
      { date: '2022-10-07T06:24:48+0000', start_time: '2022-10-07T11:30:00.590Z', end_time: '2022-10-07T13:30:00.621Z' },
      { date: '2022-10-09T06:24:48+0000', start_time: '2022-10-07T11:30:00.590Z', end_time: '2022-10-07T13:30:00.621Z' },
    ],
  },
  {
    test_track_id: '9f78aff5-9a15-46e4-9c17-d5373df0d1e2',
    list_of_slots: [{ date: '2022-10-08T06:39:33.615Z', start_time: '2022-10-07T04:30:00.590Z', end_time: '2022-10-07T13:30:00.621Z' }],
  },
]

const TestEventSlotsShow = ({ listOfSlots, style, editable }: ITestEventSlotsShow) => {
  //put list of slots when test event data is done
  // const listOfSlots = newSampleData
  const [finalSlotList, setFinalSlotList] = useState<any>()
  const testTrackIds = listOfSlots?.map((slot: any) => slot.test_track_id)
  const newTestTrackIds = listOfSlots?.map(slot => slot.test_track_id)
  // const testTrackIds = listOfSlots ? listOfSlots.map(slot => slot.id) : sampleData.map(slot => slot.id)

  const { options } = useSelect({
    resource: 'test_tracks',
    filters: [{ field: 'id', operator: 'in', value: newTestTrackIds }],
    optionLabel: 'name',
    optionValue: 'id',
    metaData: { fields: ['name', 'id'] },
  })

  // format : date1 t1-t2 t3-t4 -------- NOTE: This is old UI

  // const renderDateTime = (record: any, dates: string[]) => {
  //   console.log('curr rec', record)
  //   const timeSlotArr = dates?.map(date => {
  //     const timeSlots = record.slots[date]
  //     const displaySlots = (
  //       <>
  //         {timeSlots.map((eachSlot: string[], idx: any) => (
  //           <Tag key={idx}>
  //             <Space>
  //               <DateField value={eachSlot[0]} format="LT" />
  //               <span>to</span>
  //               <DateField value={eachSlot[1]} format="LT" />
  //               {editable && (
  //                 <Icons.CloseOutlined
  //                   style={{ cursor: 'pointer' }}
  //                   value={idx}
  //                   onClick={value => {
  //                     setFinalSlotList((prevData: any) => {
  //                       const newData = prevData.map((data: { id: string; slots: any }) => {
  //                         if (data.id === record.id) {
  //                           data.slots[date].splice(value, 1)
  //                         }
  //                         return data
  //                       })
  //                       return newData
  //                     })
  //                   }}
  //                 />
  //               )}
  //             </Space>
  //           </Tag>
  //         ))}
  //       </>
  //     )
  //     return (
  //       <List title="" pageHeaderProps={{ breadcrumb: undefined }}>
  //         {/* <Space style={{ marginBottom: '5px', flex: 'none' }} align="center"> */}
  //         <Row>
  //           <Col span={8}>
  //             <DateField value={date} format="LL" />
  //           </Col>
  //           <Col span={16}>
  //             {editable && (
  //               <Icons.CloseOutlined
  //                 style={{ cursor: 'pointer' }}
  //                 value={date}
  //                 onClick={value => {
  //                   setFinalSlotList((prevData: any) => {
  //                     const newData = prevData.map((data: { id: string; slots: any }) => {
  //                       if (data.id === record.id) {
  //                         delete data.slots[date]
  //                       }
  //                       return data
  //                     })
  //                     return newData
  //                   })
  //                 }}
  //               />
  //             )}
  //             {displaySlots}
  //           </Col>
  //         </Row>
  //       </List>
  //     )
  //   })

  //   return timeSlotArr
  // }

  // new ui implementation
  const displayDateTime = (slotArr: Array<Object>) => {
    // datetime object {{date:[[t1,t2],[t3,t4]]}}
    const dateTimeObject: any = {}
    slotArr.forEach((slot: any) => {
      const date = dayjs(slot?.date).format('DD MMM YYYY')
      if (dateTimeObject[date] === undefined) {
        dateTimeObject[date] = []
      }
      const existingSlots: any[] = dateTimeObject[date]
      existingSlots.push({ start_time: slot.start_time, end_time: slot.end_time })

      // const tabLabel = dayjs(slot.date).format('DD/MM/YYYY')
    })
    return (
      <Tabs>
        {Object.keys(dateTimeObject).map((eachDate: string, idx_root) => {
          const timeSlotsForTheDate = dateTimeObject[eachDate]?.map((eachSlot: any, idx: number) => (
            <Tag key={idx}>
              <Space>
                <DateField value={eachSlot.start_time} format="LT" />
                <span>To</span>
                <DateField value={eachSlot.end_time} format="LT" />
              </Space>
            </Tag>
          ))
          const formattedDate = dayjs(eachDate).format('DD MMM YYYY')
          return (
            <Tabs.TabPane tab={formattedDate} key={idx_root} tabKey={formattedDate}>
              {timeSlotsForTheDate?.map((eachTag: any) => eachTag)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    )
  }

  useEffect(() => {
    setFinalSlotList(listOfSlots)
  }, [listOfSlots])

  return (
    <>
      <Table dataSource={listOfSlots} bordered pagination={false} size="small" style={style}>
        <Table.Column
          width="40%"
          dataIndex="test_track_id"
          title="Test Track"
          render={value => {
            const option = options.filter(eachOption => eachOption.value === value)
            const name = option[0]?.label
            return (
              <>
                <Typography.Text>{name}</Typography.Text>
              </>
            )
          }}
        />
        {/* <Table.Column
          title="Dates and Time Slots"
          rowSpan={100}
          render={record => {
            const dates = record?.slots && Object.keys(record.slots)
            return renderDateTime(record, dates)
          }}
        /> */}
        <Table.Column
          width="60%"
          title="Dates and Time Slots"
          rowSpan={100}
          render={record => {
            const slotArr = record?.list_of_slots
            return displayDateTime(slotArr)
          }}
        />
      </Table>
    </>
  )
}

export default TestEventSlotsShow
